import { useCallback } from "react";

import { viewModelToInput } from "./converter";
import { useSiteControllerSettingTemairazuMutation } from "../../repository";

import type { SiteControllerSettingTemairazuFormModel } from "../../type";

type Props = { viewModel: SiteControllerSettingTemairazuFormModel["ViewModel"] };

export const useUpdateSiteControllerSettingTemairazu = ({ viewModel }: Props) => {
	const { onUpdate: _onUpdate } = useSiteControllerSettingTemairazuMutation();
	const onUpdate = useCallback(async () => {
		const input = viewModelToInput({ viewModel });
		return await _onUpdate({
			input,
		});
	}, [_onUpdate, viewModel]);

	return { onUpdate };
};
